import { render } from "./TemplatesShowcaseV4.vue?vue&type=template&id=8b83b19e"
import script from "./TemplatesShowcaseV4.vue?vue&type=script&lang=js"
export * from "./TemplatesShowcaseV4.vue?vue&type=script&lang=js"

import "./TemplatesShowcaseV4.vue?vue&type=style&index=0&id=8b83b19e&lang=css"
import "./TemplatesShowcaseV4.vue?vue&type=style&index=1&id=8b83b19e&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__